import { FinancialTrackerChart } from './FinancialTrackerChart';
import { ProductMixChart } from './ProductMixChart';
import { TopSpacesList } from './TopSpacesList';

export function DashboardCharts({
  revenueTrendData,
  pieData,
  topSpacesData,
}: {
  revenueTrendData: { month: string; sortKey: string; paid: number; pending: number }[];
  pieData: { name: string; value: number }[];
  topSpacesData: { id: string; name: string; count: number; revenue: number }[];
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <FinancialTrackerChart revenueTrendData={revenueTrendData} />

      <div className="flex flex-col gap-6">
        <ProductMixChart pieData={pieData} />
        <TopSpacesList topSpacesData={topSpacesData} />
      </div>
    </div>
  );
}
